/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState,useEffect } from "react";
import { useOnClickOutside } from "../../../../CommonMethods/OutsideClick";
const DropDownComponent = ({
    placeHolder,
    id,
    divClassName,
    searchParams,
    options,
    handleOnchangeInput,
    value,
    dropDownName,
    didSubDropdownChange,
    index,
    buttonDisabled,
    buttonClassName,
    dropdownId,
    test_id,
    SameName,
    optionsKey,
    isOpen,
    setisOpen,
}) => {
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef=useRef(null)

    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specified
    element. In this case, it is used to detect clicks outside of the dropdown component. When a click
    is detected outside of the dropdown component, the `setisOpen` function is called to set the
    `isOpen` state to `false`, effectively closing the dropdown. */
    useOnClickOutside(ref, () => {
        // setisOpen(true);
    });

    /**
     * The function calculates the position of a dropdown menu based on the available space on the screen.
     */
    const calculateDropdownPosition = () => {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - buttonRect.bottom-40;
        //40px
        const dropdownHeight =dropdownRef.current.clientHeight;
    
        if (spaceBelow < dropdownHeight) {
            dropdownRef.current.style.top = `-${dropdownHeight}px`;
        } else {
            dropdownRef.current.style.top = '100%';
        }
    };

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case, the
    `useEffect` hook is used to add an event listener for the `resize` event on the window object. When
    the `resize` event is triggered, the `calculateDropdownPosition` function is called to recalculate
    the position of the dropdown menu based on the available space on the screen. */
    useEffect(() => {
        window.addEventListener('resize', calculateDropdownPosition);
        calculateDropdownPosition(); // Initial position calculation
        return () => {
            window.removeEventListener('resize', calculateDropdownPosition);
        };
    }, [isOpen]);
    
    return (
        <div className={divClassName} data-te-dropdown-ref id={id} ref={ref}>
            <button
                ref={buttonRef}
                disabled={buttonDisabled !== undefined && buttonDisabled}
                title={value}
                onClick={() => setisOpen(!isOpen)}
                className={buttonClassName}
                type="button"
                id={dropDownName}
                data-testid = {test_id}
                data-te-dropdown-toggle-ref
                aria-expanded="false"
            >
                <p
                    className={`text-f7 ${
                        (value === "" || value === undefined || value === true)
                            ? "text-[#818E98]"
                            : "text-[#031624]"
                    } font-normal `}
                >
                    {(value === "" || value === undefined || value === true)
                        ? placeHolder
                        : value}
                </p>
                <img
                    src="/images/dropdown-icon.png"
                    alt="icon"
                    className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-4 ${
                        isOpen ? "transform rotate-180" : ""
                    }`}
                />
            </button>
            <ul
                ref={dropdownRef}
                className={` slct_drp_dwn min-w-full ${
                    isOpen ? "" : "hidden"
                } [&[data-te-dropdown-show]]:block`}
                aria-labelledby="dropdownMenu_acdemic_year"
                data-te-dropdown-menu-ref
                title={value}
            >
                <li className="max-h-[220px] overflow-auto scroll-bar">
                    <ul>
                        {options?.length > 0 && 
                options.map((option, i = 0) => (
                    <li
                        key={i}
                        id={dropdownId === undefined ? dropDownName : SameName === undefined ? `${dropDownName}_${i}` : optionsKey === undefined ? option.name : option[optionsKey]}
                        onClick={(e) => {
                            handleOnchangeInput(dropDownName, option, index, isOpen),
                            setisOpen(false);
                        }}
                    >
                        <a
                            title={optionsKey === undefined ? option.name : option[optionsKey]}
                            className={`${(searchParams?.get('dropname') === null || didSubDropdownChange ? value === option.name : searchParams?.get('dropname') === option.name) ? 'text-[#106EB4] ' : ''}cursor-pointer block w-full bg-white px-2 mb-2 py-1 text-f7 font-normal text-[#031624]  break-words`}
                        >
                            {optionsKey === undefined ? option.name : option[optionsKey]  }
                        </a>
                    </li>
                ))}
                    </ul>
                </li>
            </ul>
        </div>
    );
};

export default DropDownComponent;
